import { ArchivoBean } from './ArchivoBean';
import { BaseBean } from './BaseBean';
import { LenguaBean } from './LenguaBean';
import { MetaBean } from './MetaBean';
import { UbigeoBean } from './UbigeoBean';
import { VarianteLenguaBean } from './VarianteLengua';

export class AvanceBean extends BaseBean{
  public id:number;
  public descripcion:string;
  public nroElementos:number;
  public meta:MetaBean;
  public ubigeoRegion:UbigeoBean;
	public ubigeoProvincia:UbigeoBean;
	public ubigeoDistrito:UbigeoBean;
  public responsablesString:string;
  public lengua:LenguaBean;
  public varianteLengua:VarianteLenguaBean;
  public fechaAvance: Date;

  public archivosList:ArchivoBean[] = [];
  public multiplesArchivos:string;
  public valorVariableAvanceMetaList:any[]=[];

  public abrirDesdeMenu?:boolean;

  public tamanioTotalArchivo: number;
  public esIndicadorPorObjetivo:boolean=false;
  public estaAprobado:string;
  public motivo:string;
}
